module.exports = __webpack_public_path__ + "static/media/Ufesa_banner_horizontal.91a192d2.png";